import Wrapper from "../../layout/Wrapper";
import NotificationComponent from "../../screens/notifications";

import MetaComponent from "../../components/common/MetaComponent";

const metadata = {
	title: "Notification",
	description: "",
};

export default function Notifications() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<NotificationComponent />
		</Wrapper>
	);
}